"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRhumb = require("react-rhumb");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _CurrencyPicker = _interopRequireDefault(require("../common/CurrencyPicker"));

var _GrowthSuiteTitle = _interopRequireDefault(require("./GrowthSuiteTitle"));

var _GrowthSuiteTile = _interopRequireDefault(require("./GrowthSuiteTile"));

var _Calculator = _interopRequireWildcard(require("../calculator/Calculator"));

var _SuiteCalcPriceDisplayTileContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcPriceDisplayTileContainer"));

var _SuiteCalcPlanSelectorTileContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcPlanSelectorTileContainer"));

var _colors = require("HubStyleTokens/colors");

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _FooterMicrocopy = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/FooterMicrocopy"));

var _CustomerSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CustomerSupport"));

var _TabLayout = _interopRequireDefault(require("../TabLayout"));

var _StyledBlob = _interopRequireDefault(require("../common/StyledBlob"));

var _PageContainer = _interopRequireDefault(require("../common/PageContainer"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _Faq = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Faq"));

var _Question = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Question"));

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _PhoneSupportFooter = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupportFooter"));

var _reactRedux = require("react-redux");

var _FailedLoadBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/FailedLoadBanner"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _GrowthSuiteBannerSection = _interopRequireDefault(require("../banners/GrowthSuiteBannerSection"));

var _HsfsCard = _interopRequireDefault(require("../common/HsfsCard"));

var _CovidSelectors = require("../../selectors/CovidSelectors");

var _stateUtils = require("../../utils/stateUtils");

var _queryParamUtils = require("../../utils/queryParamUtils");

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  z-index: 1;\n  position: relative;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: -464px;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-left: 16px;\n    padding-right: 16px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 1280px;\n  margin: 0 auto;\n  margin-top: -413px;\n  padding: 0 80px;\n  ", ";\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 80%;\n    margin-top: 30px;\n    margin-left: auto;\n    margin-right: auto;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 16px;\n  width: 590px;\n  text-align: center;\n  margin-bottom: 20px;\n  ", ";\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      opacity: 0;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    position: relative;\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -22%;\n      background-color: ", ";\n      border-bottom-left-radius: 28%;\n      border-bottom-right-radius: 28%;\n      width: 144%;\n      height: 4%;\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  .growth-suite__blob {\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 450px;\n  margin: 40px auto;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PhoneSupportWrapper = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuitePage__PhoneSupportWrapper",
  componentId: "g1ifl2-0"
})(_templateObject(), _responsiveBreakpoints.default.phone(_templateObject2()));

var GrowthSuiteContainer = (0, _styledComponents.default)(_PageContainer.default).withConfig({
  displayName: "GrowthSuitePage__GrowthSuiteContainer",
  componentId: "g1ifl2-1"
})(_templateObject3(), _responsiveBreakpoints.default.phone(_templateObject4(), _colors.GYPSUM), _responsiveBreakpoints.default.phone(_templateObject5()));

var Blurb = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuitePage__Blurb",
  componentId: "g1ifl2-2"
})(_templateObject6(), _responsiveBreakpoints.default.tabletPortrait(_templateObject7()), _responsiveBreakpoints.default.phone(_templateObject8()));

var StyledPageContentContainer = _styledComponents.default.div.withConfig({
  displayName: "GrowthSuitePage__StyledPageContentContainer",
  componentId: "g1ifl2-3"
})(_templateObject9(), _responsiveBreakpoints.default.cs(_templateObject10()), _responsiveBreakpoints.default.phone(_templateObject11()));

var StyledUIFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "GrowthSuitePage__StyledUIFlex",
  componentId: "g1ifl2-4"
})(_templateObject12());

var GrowthSuitePage = function GrowthSuitePage(_ref) {
  var hasPricingAndPurchasingFailed = _ref.hasPricingAndPurchasingFailed,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded;
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.GROWTH_SUITE
    });
  }, []);

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      term = _useActiveTerm.activeTerm;

  var _useCalculatorState = (0, _stateUtils.useCalculatorState)(),
      _useCalculatorState2 = (0, _slicedToArray2.default)(_useCalculatorState, 2),
      calculatorState = _useCalculatorState2[0],
      setCalculatorState = _useCalculatorState2[1];

  (0, _queryParamUtils.useQueryParamsEffect)((0, _extends2.default)({
    term: term
  }, calculatorState));
  var isCovidGrowthSuitePromoEligible = (0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector);
  return _react.default.createElement(_TabLayout.default, {
    selectedPrimaryTab: "bundle",
    selectedSecondaryTab: "growth-suite"
  }, _react.default.createElement(GrowthSuiteContainer, {
    className: "growth-suite",
    "data-selenium-id": "page-success"
  }, hasPricingAndPurchasingSucceeded && _react.default.createElement(_reactRhumb.NavMarker, {
    name: "GROWTH_SUITE_PAGE"
  }), _react.default.createElement(_CurrencyPicker.default, null), _react.default.createElement(_StyledBlob.default, {
    className: "growth-suite__blob"
  }), _react.default.createElement(StyledPageContentContainer, null, _react.default.createElement(_FailedLoadBanner.default, {
    hasFailed: hasPricingAndPurchasingFailed
  }), _react.default.createElement(StyledUIFlex, {
    justify: "center",
    direction: "column",
    align: "center"
  }, _react.default.createElement(_GrowthSuiteTitle.default, null), _react.default.createElement(Blurb, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.blurb"
  }), _react.default.createElement(_UILink.default, {
    className: "m-left-1",
    external: true,
    href: (0, _urls.getSuiteLegalDisclaimerUrl)()
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.details"
  }))), _react.default.createElement(_GrowthSuiteBannerSection.default, null), _react.default.createElement(_GrowthSuiteTile.default, {
    edition: "starter",
    isCovidGrowthSuitePromoEligible: isCovidGrowthSuitePromoEligible
  }), _react.default.createElement(_GrowthSuiteTile.default, {
    edition: "professional"
  }), _react.default.createElement(_GrowthSuiteTile.default, {
    edition: "enterprise"
  }), _react.default.createElement(_HsfsCard.default, {
    growthSuitePage: true
  })), _react.default.createElement(PhoneSupportWrapper, null, _react.default.createElement(_PhoneSupport.default, {
    phoneSourceId: "growthsuite-middle",
    screen: _Tracking.SCREENS.GROWTH_SUITE
  })), _react.default.createElement(_Calculator.CalculatorContext.Provider, {
    value: {
      state: calculatorState,
      setState: setCalculatorState
    }
  }, _react.default.createElement(_Calculator.default, {
    PlanSelectorComponent: _SuiteCalcPlanSelectorTileContainer.default,
    PriceDisplayComponent: _SuiteCalcPriceDisplayTileContainer.default,
    isCovidGrowthSuitePromoEligible: isCovidGrowthSuitePromoEligible
  })), _react.default.createElement(_CustomerSupport.default, null), _react.default.createElement(_Faq.default, null, _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.whatIsIt"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.whatIsAUser"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.upfrontPayment"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.support",
    href: (0, _urls.getCommunityUrl)()
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.crmIntegration"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.emailIntegration"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.overageFees"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.onboarding"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.sendingFees"
  }), _react.default.createElement(_Question.default, {
    questionKey: "growthSuite.limits",
    href: (0, _urls.getProductsAndServicesCatalogUrl)('#TechnicalLimits')
  }), _react.default.createElement(_FooterMicrocopy.default, null)), _react.default.createElement(_PhoneSupportFooter.default, {
    phoneSourceId: "growthsuite-footer",
    screen: _Tracking.SCREENS.GROWTH_SUITE
  }))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    hasPricingAndPurchasingFailed: (0, _LoadingStateSelectors.hasPricingAndPurchasingFailedSelector)(state)
  };
};

var _default = (0, _DocumentUtils.withDocumentTitle)((0, _reactRedux.connect)(mapStateToProps)(GrowthSuitePage), 'growthSuite');

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/GrowthSuitePage.js
// module id = 853
// module chunks = 5 6